import React from 'react';
import NewsArchive from '../components/NewsArchive';
import Hero from '../components/Hero';
import CompanyStrengths from '../components/CompanyStrengths';
import Manufacturers from '../components/Manufacturers';
import ProductSlider from '../components/ProductSlider';

const HomePage = () => {
  return (
    <main className="pt-16 sm:pt-20">
      <Hero />
      <CompanyStrengths />
      <ProductSlider />
      <Manufacturers />
      <NewsArchive />
    </main>
  );
};

export default HomePage;